import { IBreadcrumb } from '@/components/types'
import { RouteRecordRaw } from 'vue-router'

export let firstMenu: any = null

export function mapMenusToRoutes(userMenus: any[]): RouteRecordRaw[] {
  const routes: RouteRecordRaw[] = []

  // 先去加载默认所有的routes
  const allRoutes: Map<string, RouteRecordRaw> = new Map()
  const routeFiles = require.context('../router/main', true, /\.ts/)
  routeFiles.keys().forEach((key) => {
    const route = require('../router/main' + key.split('.')[1]).default
    allRoutes.set(route.path, route)
  })

  firstMenu = null

  const _recurseGetRoute = (menus: any[]) => {
    let isNotice= menus.find(item => item.uri == '/main/noticeRecord')
    for (const menu of menus) {
      if (menu.uri) {
        const route = menu.path
          ? allRoutes.get(menu.path)
          : allRoutes.get(menu.uri)
        if (route) {
          routes.push(route)
        }
        if (!firstMenu) {
            if(isNotice){
              if(menu.uri == '/main/noticeRecord'){
                 firstMenu = menu
              }
            }else{
              firstMenu = menu
            }   
        }
      }
      if (menu.children) {
        _recurseGetRoute(menu.children)
      }
    }
  }

  _recurseGetRoute(userMenus)

  return routes
}

export function pathMapToMenu(userMenus: any[], path: string): any {
  for (const menu of userMenus) {
    if (menu.uri && menu.uri === path) {
      return menu
    }

    for (const subMenu of menu.children) {
      if (subMenu.uri === path) {
        return subMenu
      }
    }
  }

  return userMenus[0].children[0]
}

export function pathMapToBreadcrumbs(
  userMenus: any[],
  path: string
): IBreadcrumb[] {
  const breadcrumbs: IBreadcrumb[] = []

  for (const menu of userMenus) {
    if (menu.uri && menu.uri === path) {
      breadcrumbs.push({
        name: menu.name,
        path: menu.uri
      })
    }

    for (const subMenu of menu.children) {
      if (subMenu.uri === path) {
        breadcrumbs.push({
          name: menu.name
        })
        breadcrumbs.push({
          name: subMenu.name,
          path: subMenu.uri
        })
      }
    }
  }

  return breadcrumbs
}

export function mapMenusToPermissions(userMenus: any[]) {
  const permissions: string[] = []

  for (const menu of userMenus) {
    for (const subMenu of menu.children) {
      for (const permission of subMenu.children) {
        permissions.push(permission.value)
      }
    }
  }
  return permissions
}

export function menuMapLeafKeys(menuList: any[]) {
  const leftKeys: string[] = []

  const _recurseGetLeaf = (menuList: any[]) => {
    for (const menu of menuList) {
      if (menu.permissions && menu.permissions.length > 0) {
        _recurseGetLeaf(menu.permissions)
      } else {
        leftKeys.push(menu.id)
      }
    }
  }
  _recurseGetLeaf(menuList)

  return leftKeys
}
